import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import useAuth from 'auth/useAuth';
import { isSettingsSection, isSettingsSectionVisible, SettingsSectionKey } from './sections';

export const useSettingsNav = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isSuperuser } = useAuth();
  const raw = searchParams.get('config');
  const section: SettingsSectionKey | null =
    isSettingsSection(raw) && isSettingsSectionVisible(raw, isSuperuser) ? raw : null;

  const open = useCallback((key: SettingsSectionKey) => setSearchParams({ config: key }), [setSearchParams]);
  const close = useCallback(() => setSearchParams({}), [setSearchParams]);

  return { section, isOpen: section != null, open, close };
};
